import e from "./createTheme.mjs";
const t = e(), m = t;
export {
  m as default
};
//# sourceMappingURL=defaultTheme.mjs.map
